import { z } from "zod";

export const zId = z.union([z.string(), z.number()]);

export type ZId = z.infer<typeof zId>;
